@if (hasHref() && shouldShowControl()) {
  <div class="d-flex">
    <a [routerLink]="[href]">{{ label }}</a>
  </div>
}
